import { useEffect } from "react"
import Header from "../components/Header"
import Hero from "../components/landing-page/Hero"
import Layout from "../components/Layout"

import AiIntegration from "../components/AI-Integration/AI-Integration"
import AttendeeVoices from "../components/landing-page/AttendeeVoices"
import DashboardIntro from "../components/landing-page/DashboardIntro"
import FAQSection from "../components/landing-page/FaqSection"
import { BackgroundGradient } from "../components/landing-page/GradientBackground"
import HighlightCaseStudy from "../components/landing-page/HighlightCaseStudy"
import OrganicReach from "../components/landing-page/OrganicReach"
import PremagicNewsCard from "../components/landing-page/PremagicNews"
import RealEventsSection from "../components/landing-page/RealEventsSection"
import Testimonial from "../components/landing-page/Testimonial"
import UserInsights from "../components/landing-page/UserInsight"
import "../index.css"
import AnnouncementBanner from "../components/AnnouncementBanner"
import PremagicNewsSection from "../components/PremagicNews"

// Extend the Window interface to include the PM property
declare global {
  interface Window {
    PM: {
      APP_VERSION: string | undefined
    }
  }
}

export function Index() {
  useEffect(() => {
    window.PM = {
      APP_VERSION: process.env.GATSBY_APP_VERSION,
    }
  }, [])

  const isMobileMenuopen =
    (typeof window !== "undefined" &&
      document.body.classList.contains("mobile-menu-open")) ||
    false

  return (
    <Layout
      title="Premagic - Turn Every Attendee Into Your Event Marketer"
      description="The AI event marketing platform behind GITEX, Informa Connect & 2000+ events. Run pre-event, during-event & post-event campaigns that get attendees sharing, drive organic buzz, and bring in more registrations; without ad spend."
      isHomePage
    >
      <AnnouncementBanner />
      <Header isHome />
      <Hero />
      <HighlightCaseStudy />
      <BackgroundGradient>
        <RealEventsSection />
        <DashboardIntro />
      </BackgroundGradient>
      <PremagicNewsSection isHomePage />
      <Testimonial />
      <UserInsights />
      <AttendeeVoices />
      <AiIntegration />
      <FAQSection />
      <OrganicReach />
    </Layout>
  )
}

export default Index
